import api from "@/lib/api";

export default {
  updateNotification(payload) {
    return api.put(
      "/api/v1/notification/atualizar-configuracao",
      { configuracao: JSON.stringify(payload) },
      { showSuccessToast: true }
    );
  },
};
